<template>
  <v-navigation-drawer
    v-model="discussionSidebar"
    fixed
    right
    width="480"
  >
    <v-toolbar flat color="white">
      <v-btn icon @click="$emit('closeDiscussionSidebar')">
        <v-icon color="grey darken-2">mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title
        class="font-weight-regular grey--text text--darken-2"
      >
        Discussão
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        v-show="!showNewComment"
        small
        flat
        color="blue"
        @click="showNewComment = true"
      >
        <v-icon size="20" left>mdi-comment-plus-outline</v-icon>
        Adicionar comentário
      </v-btn>
    </v-toolbar>

    <empty-document-discussion
      class="mt-5 pa-4"
      v-if="isEmpty(comments) && !showNewComment"
    />

    <new-comment
      class="pa-4"
      v-if="showNewComment"
      @hideNewComment="showNewComment = false"
      :doc="doc"
    />

    <v-layout column class="py-3 px-4">
      <v-layout
        class="mb-3"
        column
        v-for="comment in comments"
        :key="comment.id"
      >
        <v-layout
          align-center
          class="mb-2"
        >
          <v-avatar class="mr-2" size="24">
            <img :src="comment.user.avatar"  />
          </v-avatar>
          <v-layout column>
            <span class="body-2 grey--text text--darken-2">{{ capitalizeText(comment.user.name) }}</span>
            <span class="caption grey--text text--lighten-1">{{ comment.user.role.name }}</span>
          </v-layout>
          <span class="caption grey--text">{{ commentDate(comment.created_at) }}</span>
        </v-layout>

        <v-card
          class="comment-container"
          flat
          color="grey lighten-3"
        >
          <v-card-text class="grey--text text--darken-2">
            <div class="word-break" wrap>
              {{comment.content}}
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { last, lowerCase, startCase, isEmpty, orderBy, find } from 'lodash';
import colors from 'vuetify/es5/util/colors';
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import EmptyDocumentDiscussion from '@/components/document/show/EmptyDocumentDiscussion';
import NewComment from '@/components/document/show/NewComment';

export default {
  name: 'DocumentDiscussion',
  components: {
    EmptyDocumentDiscussion,
    NewComment,
  },
  props: {
    doc: {
      type: Object,
      default: () => {},
    },
    discussionSidebar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colors,
      last,
      format,
      isEmpty,
      showNewComment: false,
    };
  },
  methods: {
    capitalizeText(string) {
      const lowerCaseText = lowerCase(string);
      return startCase(lowerCaseText);
    },
    commentDate(date) {
      const today = format(new Date(), 'DD/MM/YYYY');
      if (format(date, 'DD/MM/YYYY') === today) {
        return 'Hoje';
      }
      const day = format(date, 'DD');
      const month = startCase(format(date, 'MMMM'), { locale: ptLocale });
      const year = format(date, 'YYYY');
      return `${day} de ${month} de ${year}`;
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    user() {
      return this.$store.getters.user;
    },
    canEditAndRemove() {
      return this.user.id === this.doc.user.id &&
      this.doc.mime_type === 'application/pdf' &&
      this.doc.document_state.state !== 'DocGo';
    },
    canWithdraw() {
      return this.doc.document_state.state === 'DocGo' &&
      (this.user.super_admin || this.user.id === this.doc.user.id);
    },
    lastUpdate() {
      const lastLog = last(this.doc.activity_logs);
      const lastUpdate = last(lastLog.logs);
      const lastUpdateDay = format(lastUpdate.updated_at, 'DD');
      const lastUpdateMonth = startCase(format(lastUpdate.updated_at, 'MMMM', { locale: ptLocale }));
      const lastUpdateYear = format(lastUpdate.updated_at, 'YYYY');
      return `${lastUpdateDay} de ${lastUpdateMonth} de ${lastUpdateYear}`;
    },
    createdAt() {
      const createdAtDay = format(this.doc.created_at, 'DD');
      const createdAtMonth = startCase(format(this.doc.created_at, 'MMMM', { locale: ptLocale }));
      const createdAtYear = format(this.doc.created_at, 'YYYY');
      return `${createdAtDay} de ${createdAtMonth} de ${createdAtYear}`;
    },
    comments() {
      const doc = find(this.folder.documents, ['id', this.doc.id]);
      return orderBy(doc.comments, ['id'], ['desc']);
    },
  },
};
</script>

<style scoped>
  .comment-container {
    border-radius: 3px;
  }
  .word-break {
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/document/show/DocumentDiscussion.vue